import { render, staticRenderFns } from "./GBSelectMemberListRow.vue?vue&type=template&id=20e524b2&scoped=true&"
import script from "./GBSelectMemberListRow.vue?vue&type=script&lang=js&"
export * from "./GBSelectMemberListRow.vue?vue&type=script&lang=js&"
import style0 from "./GBSelectMemberListRow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBSelectMemberListRow.vue?vue&type=style&index=1&id=20e524b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e524b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAvatar,VIcon})
